export var PROCESS_CPU_WARN_THRESHOLD_PERC = 10;
export var PROCESS_MEM_WARN_THRESHOLD_KB = 122880;
export var PROCESS_UPTIME_WARN_SECS = 300;
export var FILESYSTEM_SPACE_THRESHOLD_PERC = 90;
export var SYSTEM_CPU_WARN_THRESHOLD_PERC = 60;
export var SYSTEM_MEM_WARN_THRESHOLD_PERC = 80;
